import GQLClient from './GQLClient';
import ky from 'ky';
import { crossEnv } from '@sbvr/lbe-environment';

export const gql = new GQLClient(crossEnv.API_URL, ky);

export * from './plugins/AuthPlugin';
export * from './plugins/CancelPlugin';
export * from './plugins/ErrorHandlingPlugin';
export * from './plugins/ErrorNotifierPlugin';
export * from './plugins/LocalePlugin';
export * from './plugins/RemoveUnderscoredPropertiesPlugin';
export * from './plugins/TransactionTrackingPlugin';
